module.exports = __webpack_public_path__ + "files/02d39ba454cd1390be929e5717356bba.png";